import counterUp from 'counterup2';

import '../../sass/blocks/home-intro.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $homeIntros = document.querySelectorAll('.home-intro');

    if (!$homeIntros) return;

    $homeIntros.forEach($homeIntro => {
        const $statNumbers = $homeIntro.querySelectorAll('.home-intro__stat-number');

        const initNumberAnimations = () => {
            if (!$statNumbers) return;

            $homeIntro.addEventListener('onscreen', () => {
                if (!noMotionPreference.matches || $homeIntro.classList.contains('home-intro--has-animated')) return;

                $statNumbers.forEach($statNumber => {
                    counterUp($statNumber, {
                        duration: 1000,
                        delay: 2
                    });

                    $homeIntro.classList.add('home-intro--has-animated');
                });
            });

            $homeIntro.addEventListener('offscreen', () => {
                $homeIntro.classList.remove('home-intro--has-animated');
            });
        };

        initNumberAnimations();
    })
})();
